import { AdminApi } from 'stylemix-vue-admin'

export default class CouponsApi extends AdminApi {
  constructor(parameters) {
    super('coupons', parameters)
  }
}
